import { AxiosResponse } from 'axios';
import { pickBy } from 'lodash';

import {
  ClientsListResponse,
  AddClientParams,
  ClientExtendedInfo,
  EditClientParams,
  GetClientsParams,
  ReservedClientName,
  SubscriptionResponse,
  EditClientResponse,
  StripeSubscriptionUrlResponse,
} from 'types/clients';
import { trimItems } from 'utils';

import { api } from './setupApi';

class ClientsModel {
  link = '/clients';

  stripeLink = '/stripe';

  getClients = (params: GetClientsParams): Promise<ClientsListResponse> =>
    api.get<ClientsListResponse>(`${this.link}/search`, { params }).then(({ data }) => data);

  getClient = (id: number): Promise<ClientExtendedInfo> =>
    api.get<ClientExtendedInfo>(`${this.link}/${id}`).then(({ data }) => data);

  addClient = (data: AddClientParams) =>
    api.post(this.link, trimItems(data, ['name', 'fullName'])).then(({ data: { client } }) => client);

  editClient = (id: number, data: EditClientParams) => {
    const dataToSave = pickBy(trimItems(data, ['name', 'fullName']), val => val !== '');

    return api.put<EditClientResponse>(`${this.link}/${id}`, dataToSave).then(({ data }) => data);
  };

  deleteClient = (id: number) => api.delete(`${this.link}/${id}`);

  checkReservedName = (name: string) => api.get(`${this.link}/check_reserved_name`, { params: { name } });

  getCurrentSubscripiton = (id: number): Promise<AxiosResponse<SubscriptionResponse | null>> =>
    api.get(`${this.link}/${id}/current_subscription`);

  getStripeSubscriptionUrl = (): Promise<StripeSubscriptionUrlResponse> =>
    api.get<StripeSubscriptionUrlResponse>(`${this.stripeLink}/stripe_session`).then(({ data }) => data);
}

export const clientsModel = new ClientsModel();
